var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"block",class:{ shadow: _vm.shadow }},_vm._l((_vm.cells),function(cell){return _c('cell',{key:cell.id,attrs:{"data":cell.data,"stage":_vm.stage,"pos":cell.pos}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }